import React from 'react';
import styles from './SliderButton.module.scss';

const SliderButton = (props) => {

  const onGoTo = dir => {
    props.slider.current.slider.goTo(dir);}
  const imgSource = (props.direction == "next") ? "./img/fc_icon-arrow-next.svg" :"./img/fc_icon-arrow-prev.svg"


  return(
    <div className={[styles.button, styles[props.direction], styles[props.color], props.direction].join(' ')} >
        <div className={styles.imageContainer}><img src={ imgSource } alt={ props.direction } /></div>
    </div>
  )
};

const SliderControls = (props) => {

  return(
    <div className={`sliderControls ${props.additionalClass}`}>
      <SliderButton direction="previous" slider={props.slider} color={props.color}></SliderButton>
      <SliderButton direction="next" slider={props.slider} color={props.color}></SliderButton>
    </div>
  )
};
SliderControls.defaultProps = {
  additionalClass: 'Test'
};

// export {SliderControls};
export default SliderControls;
